
<template>
  <div class="zrqBox">
    <van-cell-group class="currentZrqPosition" v-if="selectZrqList[0]">
      <van-field
        label="当前："
        left-icon="location-o"
        :right-icon="selectZrqList[1] ? 'arrow' : ''"
        v-model="zrqName"
        readonly
        @click="checkZrqPicker"
      />
    </van-cell-group>

    <!-- 地图页 -->
    <div class="bigForestMap" v-if="!nonePageShow">
      <zrq :mapData="mapData" mode="h5" @on-load="onMapLoad"></zrq>
    </div>

    <!-- 弹出框 -->
    <van-popup v-model="selectZrqPicker" class="zrqPickerPage">
      <zrq-select :zrqData="zrqData" @getData="changeZrq"></zrq-select>
    </van-popup>
    <!-- 组件弹框 -->
    <div class="nonePage" v-if="nonePageShow && loadingEnd">
      <img :src="nonePng" alt />
      <p>暂无责任区</p>
    </div>
    <!-- 提示有限制的查看责任区信息 -->
    <!-- 因数据安全需要，已设置安全限制GIS数据将无法访问和查看！ -->
    <van-notice-bar left-icon="volume-o" :scrollable="false" class="vanSwipe" v-if="isFilter">
      <van-swipe
        vertical
        class="noticeSwiper"
        :autoplay="3000"
        :show-indicators="false"
      >
        <van-swipe-item
          >因数据安全需要，已设置安全限制GIS数据将无法访问和查看！</van-swipe-item
        >
        <van-swipe-item
          >因数据安全需要，已设置安全限制GIS数据将无法访问和查看！</van-swipe-item
        >
        <van-swipe-item
          >因数据安全需要，已设置安全限制GIS数据将无法访问和查看！</van-swipe-item
        >
      </van-swipe>
    </van-notice-bar>
  </div>
</template>
<script>
/*eslint-disable*/
const zrqSelect = () => import("@/components/zrqSelect/zrqSelect");
const zrq = () => import("@/views/map/Zrq");
import { mapState, mapMutations } from "vuex";

import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import nonePng from "@/assets/none.png";
export default {
  name: "zrqBox",
  components: {
    zrqSelect,
    zrq,
  },
  data() {
    return {
      isFilter:false,//是否脱敏提示
      nonePng: nonePng, //默认图片
      nonePageShow: false,
      loadingEnd: false,
      userId: "",
      mapData: {
        zrqlx: "",
        zrqobjid: "",
        toolbar: "block",
      },
      zrqData: {
        uid: "",
        objid: "",
        zrqName: "",
      },
      tabTypeText: "",

      showLoadPage: true,
      zrqName: "",
      selectZrqPicker: false,
      selectZrqList: [],
      clientType: "", //手机类型
    };
  },

  mounted() {
    document.title = "责任区";
    this.clientType = getDeviceType();
    this.userId = this.$route.query.uid;
    this.initData();
  },
  methods: {
    // 是否显示脱敏接口反给父级
    onMapLoad(i){
      this.isFilter=i;
    },
    checkZrqPicker() {
      let _this = this;
      if (_this.selectZrqList[1]) {
        this.selectZrqPicker = true;
      } else {
        _this.$toast("当前仅有一个责任区");
      }
    },
    initData() {
      let _this = this;
      _this.$api.universal.dutyArea
        .getDutyAreaList(_this.userId)
        .then((res) => {
          if (res.code == "1" && res.data) {
            console.log("112233");
            _this.selectZrqList = res.data;
            _this.linUserId = _this.userId;
            _this.tabTypeText = res.data[0].type;
            _this.mapData.zrqlx = _this.getZrqLx(
              res.data[0].type,
              res.data[0].level
            );
            _this.mapData.zrqobjid = res.data[0].objid;
            _this.zrqName = res.data[0].zqName;
            _this.zrqData.uid = _this.userId;
            _this.zrqData.objid = res.data[0].objid;
            _this.zrqData.zrqName = res.data[0].zqName;
          } else {
            _this.nonePageShow = true;
            _this.loadingEnd = true;
            _this.mapData.zrqlx = "";
            _this.mapData.zrqobjid = "";
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeZrq(data) {
      let _this = this;
      this.selectZrqPicker = false;
      if (data.objid && data.zrqName) {
        _this.tabTypeText = data.type;

        _this.mapData.zrqobjid = data.objid;
        _this.$set(
          _this.mapData,
          "zrqlx",
          _this.getZrqLx(data.type, data.level)
        );
        _this.zrqName = data.zrqName;
        _this.zrqData.uid = _this.userId;
        _this.zrqData.objid = data.objid;
        _this.zrqData.zrqName = data.zrqName;
      }
    },
    getZrqLx(type, level) {
      let lx = "",
        zqList = ["geo_sheng", "geo_shi", "geo_xian", "geo_xiang", "geo_cun"],
        zrqList = [
          "geo_grid_sheng",
          "geo_grid_shi",
          "geo_grid_xian",
          "geo_grid_xiang",
          "geo_grid_cun",
        ];
      if (type == "zq") {
        lx = zqList[level - 1];
      } else {
        lx = zrqList[level - 1];
      }
      return lx;
    },
  },
};
</script>
<style lang="less">
.zrqBox {
  width: 100%;
  height: 100%;
  position: relative;
  .currentZrqPosition {
    .van-field__label {
      width: 55px;
    }
    .van-field__left-icon {
      color: #4bc08a;
    }
    .van-field__right-icon{
      color: #4bc08a;
    }
    .van-cell__title {
      span {
        font-size: 15px;
        color: #626064;
      }
    }
    .van-cell__value {
      .van-field__control {
        text-align: left;
        font-size: 15px;
        color: #4bc985;
      }
    }
  }

  .bigForestMap {
    height: calc(100% - 45px);
  }

  .zrqPickerPage {
    width: 100%;
    height: 100%;
  }
  .van-popup--center.zrqPickerPage {
    top: 0;
    left: 0;
    transform: initial;
  }
  .nonePage {
    width: 120px;
    height: 150px;

    position: absolute;
    left: 50%;
    margin-left: -60px;
    top: 50%;
    margin-top: -75px;

    img {
      display: block;
      max-width: 100px;
      max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
    }
  }
  .vanSwipe {
    width: 100%;
    position: absolute;
    top: 45px;
    left: 0;
    background: #4bc985;
    height: 30px;
    .van-icon{
      color: #fff;
    }
    .van-notice-bar__wrap {
      height: 25px;
    }
    .noticeSwiper {
      font-size: 12px;
      width: 350px;
      height: 25px;
      line-height: 25px;
      color: #fff;
      background: #4bc985;
      position: relative;
    }
  }
}
</style>